import React from 'react'

import { Info } from 'lucide-react'

import { useTranslation } from '@/core/i18n/useTranslation'

import SelectableBadge from '../SelectableBadge'

interface AudienceSectionProps {
	ageTags: Array<{ key: string; display: string }>
	genderTags: Array<{ key: string; display: string }>
	socioeconomicTags: Array<{ key: string; display: string }>
	selectedAgeTags: string[]
	selectedGender: string
	selectedSocioeconomicTags: string[]
	onAgeTagToggle: (tag: string) => void
	onGenderSelect: (tag: string) => void
	onSocioeconomicToggle: (tag: string) => void
}

export const AudienceSection: React.FC<AudienceSectionProps> = ({
	ageTags,
	genderTags,
	socioeconomicTags,
	selectedAgeTags,
	selectedGender,
	selectedSocioeconomicTags,
	onAgeTagToggle,
	onGenderSelect,
	onSocioeconomicToggle,
}) => {
	const { t } = useTranslation('common')

	return (
		<div className="space-y-6">
			<h2 className="text-lg font-semibold">{t('account.brand.audience')}</h2>

			<div className="flex flex-col gap-2">
				<label className="text-sm font-medium">{t('account.brand.age')}</label>
				<div className="flex flex-wrap gap-2">
					{ageTags.map((tag) => (
						<SelectableBadge
							key={tag.key}
							tag={tag.display}
							isSelected={selectedAgeTags.includes(tag.key)}
							onClick={() => onAgeTagToggle(tag.key)}
						/>
					))}
				</div>
			</div>

			<div className="flex flex-col gap-2">
				<label className="text-sm font-medium">
					{t('account.brand.gender')}
				</label>
				<div className="flex gap-2">
					{genderTags.map((tag) => (
						<SelectableBadge
							key={tag.key}
							tag={tag.display}
							isSelected={selectedGender === tag.key}
							onClick={() => onGenderSelect(tag.key)}
						/>
					))}
				</div>
			</div>

			<div className="flex flex-col gap-2">
				<div className="flex items-center gap-2">
					<label className="text-sm font-medium">
						{t('account.brand.socioeconomic_level')}
					</label>
					<Info className="w-4 h-4 text-muted-foreground" />
				</div>
				<div className="flex flex-wrap gap-2">
					{socioeconomicTags.map((tag) => (
						<SelectableBadge
							key={tag.key}
							tag={tag.display}
							isSelected={selectedSocioeconomicTags.includes(tag.key)}
							onClick={() => onSocioeconomicToggle(tag.key)}
						/>
					))}
				</div>
			</div>
		</div>
	)
}
